import { ProtectedRoute } from "@app/protected-route";
import StressTestMetricDoc from "@pages/stress-test/stress-test-metric-doc";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/stress-test/docs/$metric")({
	component: RouteComponent,
});

function RouteComponent() {
	const { metric } = Route.useParams();
	return (
		<ProtectedRoute requiredPermissions={["perform_ifrs"]}>
			<StressTestMetricDoc metric={metric} />
		</ProtectedRoute>
	);
}
